export const getInitials = (name: string) => {
  const trimmedName = name.trim();

  if (!trimmedName) {
    return undefined;
  }

  // Filter possible empty string items if there are multiple spaces
  const words = trimmedName.split(' ').filter(Boolean);

  if (words.length > 1) {
    return `${words[0][0].toUpperCase()}${words[1][0].toUpperCase()}`;
  }

  return words[0][0].toUpperCase();
};
